import { EMPTY_CATALOGUE, type Catalogue } from '@adthlete/common/utils/academy'
import { useGetAcademyProgressQuery } from '@/redux/collaborationsApi'

/** The published Academy catalogue (already fetched with the athlete's progress) */
export function useAcademyCatalogue(): Catalogue {
  const { catalogue } = useGetAcademyProgressQuery(undefined, {
    selectFromResult: ({ data }) => ({ catalogue: data?.catalogue }),
  })
  return catalogue ?? EMPTY_CATALOGUE
}
